module.exports = __webpack_public_path__ + "static/media/Entrepreneur.07f32a63.jpeg";